import { Form, Formik } from "formik";
import React from "react";


import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import marker from "../assets/location.svg";
import { useToast } from "../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../redux/reducers/loadingReducer";
import { userState } from "../redux/reducers/userReducer";
import axiosInstance from "../utils/axiosInstance";
import { getUrlForEvent, getUrlForUsers } from "../utils/confighelpers";
import { TwButton, TwLocationInput } from "./tailwind";
import { useTranslation } from "react-i18next";

export default function ChangeLocationModal({
  open,
  handleClose,
  sessionData,
  instanceId,
  handleUpdate,
}) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [userLocations, setUserLocations] = React.useState([]);
  const [sessionDetails, setSessionDetails] = React.useState(null);

  React.useEffect(() => {
    (async () => {
      if (open) {
        const locsConfig = {
          method: "get",
          url: `${getUrlForUsers()}listOfLocation`,
        };
        dispatch(setGlobalLoading(true));
        const requestLocs = await axiosInstance(locsConfig);
        dispatch(setGlobalLoading(false));
        setUserLocations([...requestLocs.data.data]);
        const sessionDetailsConfig = {
          method: "get",
          url: `${getUrlForEvent()}schedule/get?eventScheduleId=${sessionData._id}`,
        };
        const sessionDetailsRequest = await axiosInstance(sessionDetailsConfig);
        setSessionDetails(sessionDetailsRequest.data.data);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">{t("inputFieldsTitle.close")}</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            <div className="sm:flex sm:items-center">
              <div className="mt-3 text-center sm:mx-4 sm:mt-0 sm:text-left w-full">
                <DialogTitle as="h3" className="text-xl font-semibold text-gray-900">
                  {t("inputFieldsTitle.updateLocation")}
                </DialogTitle>
                <div className="mt-2">
                  <Formik
                    initialValues={{
                      location: sessionData.location,
                    }}
                    validate={(values) => {
                      const errors = {};
                      if (!Object.keys(values.location).length) {
                        errors.location = t("errors.required");
                      }
                      return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                      setSubmitting(true);

                      const body = {
                        eventScheduleId: sessionDetails._id,
                        location: {
                          locationId: values.location._id,
                          address: values.location.address,
                          addressName: values.location.addressName,
                          houseNumber: values.location.houseNumber,
                          city: values.location.city,
                          zip: values.location.zip ? values.location.zip : "",
                          location: values.location.location,
                        },
                      };
                      const config = {
                        method: "put",
                        url: `${getUrlForEvent()}schedule/update`,
                        data: body,
                      };
                      dispatch(setActionLoading(true));
                      const request = await axiosInstance(config);
                      dispatch(setActionLoading(false));
                      if (request.status === 200) {
                        if (request.data.statusCode === 200) {
                          addSuccessToast(t("successes.success"));
                          setSubmitting(false);
                          handleClose();
                          handleUpdate();
                        } else {
                          setSubmitting(false);
                          addErrorToast(request.data.message);
                        }
                      }
                    }}
                  >
                    {({ values, errors, setFieldValue, submitForm, isSubmitting }) => (
                      <Form className="flex flex-col gap-4 w-full">
                        <TwLocationInput
                          label={t("myEvents.location")}
                          name={"location"}
                          leftIcon={(<img className={""} src={marker} alt={""} />)}
                          defaultLocationSelect={values.location}
                          onLocationSelect={(data, postAdd) => {

                            // const newValue = JSON.parse(postAdd);
                            const newValue = data;

                            setFieldValue("location", newValue);
                            if (newValue != null) {
                              // handleLocationChange(newValue);
                            }

                            // setAddress(data);
                          }}
                          errors={errors}
                        />
                        {/* <TwSelectGroup
                          label={t("myEvents.location")}
                          placeholder={t("myEvents.selectLocation")}
                          name={"location"}
                          leftIcon={<img src={marker} alt={""} className="w-4" />}
                          options={[...userLocations.length ? userLocations.map((loc, idx) => {
                            return { value: JSON.stringify(loc), title: loc.addressName }
                          }) : []]}
                          defaultValue={JSON.stringify(values.location)}
                          value={JSON.stringify(values.location)}
                          onChange={(event) => {
                            const newValue = JSON.parse(event.target.value);
                            setFieldValue("location", newValue);
                          }}
                          errors={errors} /> */}
                        <TwButton
                          variant={"secondary"}
                          onClick={submitForm}
                          // disabled={userLocations.length <= 0 || loadingReduxState.actionLoading}
                          disabled={loadingReduxState.actionLoading}
                          actionLoading={(loadingReduxState.actionLoading)}
                        >
                          {t("update")}
                        </TwButton>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
